import { ENDORSEMENT_ACTIONS } from "./constants";

export const SUM_INSURED_OPTIONS = [
  { id: 1, label: "3 lacs", value: 300000 },
  { id: 2, label: "4 lacs", value: 400000 },
  { id: 3, label: "5 lacs", value: 500000 },
  {
    id: 4,
    label: "7.5 lacs",
    value: 750000,
  },
  {
    id: 5,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 6,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 7,
    label: "20 lacs",
    value: 2000000,
  },
  {
    id: 8,
    label: "25 lacs",
    value: 2500000,
  },
  {
    id: 9,
    label: "50 lacs",
    value: 5000000,
  },
  {
    id: 10,
    label: "75 lacs",
    value: 7500000,
  },
  {
    id: 11,
    label: "1 crore",
    value: 10000000,
  },
  {
    id: 12,
    label: "2 crore",
    value: 20000000,
  },
  {
    id: 13,
    label: "3 crore",
    value: 30000000,
  },
  {
    id: 14,
    label: "5 crore",
    value: 50000000,
  },
];
export const POSP_SUM_INSURED = [{ id: 1, label: "5 lacs", value: 500000 }];
export const DEDUCTIBLE = [
  { id: 1, label: "2 lacs", value: 200000 },
  { id: 2, label: "3 lacs", value: 300000 },
  { id: 3, label: "5 lacs", value: 500000 },
  { id: 4, label: "10 lacs", value: 1000000 },
  { id: 5, label: "15 lacs", value: 1500000 },
  { id: 6, label: "20 lacs", value: 2000000 },
];
export const MEDICARE_RESERVE_DEDUCTIBLE = [
  { id: 1, label: "2 lacs", value: 200000 },
  { id: 2, label: "3 lacs", value: 300000 },
  { id: 3, label: "5 lacs", value: 500000 },
  { id: 4, label: "10 lacs", value: 1000000 },
  { id: 5, label: "15 lacs", value: 1500000 },
  { id: 6, label: "20 lacs", value: 2000000 },
  { id: 7, label: "25 lacs", value: 2500000 },
  { id: 8, label: "50 lacs", value: 5000000 },
];
export const POSP_DEDUCTIBLE = [
  { id: 1, label: "2 lacs", value: 200000 },
  { id: 2, label: "3 lacs", value: 300000 },
  { id: 3, label: "5 lacs", value: 500000 },
];

export const SUPER_CHARGE_SUM_INSURED = [
  { id: 1, label: "5 lacs", value: 500000 },
  {
    id: 2,
    label: "7.5 lacs",
    value: 750000,
  },
  {
    id: 3,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 4,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 5,
    label: "20 lacs",
    value: 2000000,
  },
];
export const ELDERCARE_SUM_INSURED = [
  { id: 1, label: "5 lacs", value: 500000 },

  {
    id: 2,
    label: "10 lacs",
    value: 1000000,
  },

  {
    id: 3,
    label: "25 lacs",
    value: 2500000,
  },
];
export const MEDICARE_PLUS_SUM_INSURED = [
  { id: 1, label: "3 lacs", value: 300000 },
  { id: 2, label: "5 lacs", value: 500000 },

  {
    id: 3,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 4,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 5,
    label: "20 lacs",
    value: 2000000,
  },
  {
    id: 6,
    label: "25 lacs",
    value: 2500000,
  },
  {
    id: 7,
    label: "50 lacs",
    value: 5000000,
  },
  {
    id: 8,
    label: "1 crore",
    value: 10000000,
  },
];
export const MEDICARE_LITE_SUM_INSURED = [
  { id: 1, label: "5 lacs", value: 500000 },
  {
    id: 2,
    label: "7.5 lacs",
    value: 750000,
  },
  {
    id: 3,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 4,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 5,
    label: "20 lacs",
    value: 2000000,
  },
];
export const MEDICARE_SUM_INSURED = [
  { id: 1, label: "3 lacs", value: 300000 },
  {
    id: 2,
    label: "4 lacs",
    value: 400000,
  },
  {
    id: 3,
    label: "5 lacs",
    value: 500000,
  },
  {
    id: 4,
    label: "7.5 lacs",
    value: 750000,
  },
  {
    id: 5,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 6,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 7,
    label: "20 lacs",
    value: 2000000,
  },
];
export const MEDICARE_PREMIER_SUM_INSURED = [
  { id: 1, label: "5 lacs", value: 500000 },
  {
    id: 2,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 3,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 4,
    label: "20 lacs",
    value: 2000000,
  },
  {
    id: 5,
    label: "25 lacs",
    value: 2500000,
  },
  {
    id: 6,
    label: "50 lacs",
    value: 5000000,
  },
  {
    id: 7,
    label: "75 lacs",
    value: 7500000,
  },
  {
    id: 8,
    label: "1 crore",
    value: 10000000,
  },
  {
    id: 9,
    label: "2 crore",
    value: 20000000,
  },
  {
    id: 10,
    label: "3 crore",
    value: 30000000,
  },
];
export const MEDICARE_SELECT_SUM_INSURED = [
  { id: 1, label: "5 lacs", value: 500000 },
  {
    id: 2,
    label: "7.5 lacs",
    value: 750000,
  },
  {
    id: 3,
    label: "10 lacs",
    value: 1000000,
  },
  {
    id: 4,
    label: "15 lacs",
    value: 1500000,
  },
  {
    id: 5,
    label: "20 lacs",
    value: 2000000,
  },
  {
    id: 6,
    label: "25 lacs",
    value: 2500000,
  },
  {
    id: 7,
    label: "50 lacs",
    value: 5000000,
  },
  {
    id: 8,
    label: "75 lacs",
    value: 7500000,
  },
  {
    id: 9,
    label: "1 crore",
    value: 10000000,
  },
  {
    id: 10,
    label: "2 crore",
    value: 20000000,
  },
  {
    id: 11,
    label: "3 crore",
    value: 30000000,
  },
];
export const MEDICARE_RESERVE_SUM_INSURED = [
  ...MEDICARE_SELECT_SUM_INSURED,
  {
    id: 12,
    label: "5 crore",
    value: 50000000,
  },
];
export const MEDICARE_SELECT_ELITE_SUM_INSURED = [
  {
    id: 1,
    label: "25 lacs",
    value: 2500000,
  },
  {
    id: 2,
    label: "50 lacs",
    value: 5000000,
  },
  {
    id: 3,
    label: "75 lacs",
    value: 7500000,
  },
  {
    id: 4,
    label: "1 crore",
    value: 10000000,
  },
  {
    id: 5,
    label: "2 crore",
    value: 20000000,
  },
  {
    id: 6,
    label: "3 crore",
    value: 30000000,
  },
];
export const SALUTATION = [
  { id: 1, label: "Mr", value: "Mr" },
  { id: 2, label: "Mrs", value: "Mrs" },
  { id: 3, label: "Ms", value: "Ms" },
  { id: 4, label: "Prof", value: "Prof" },
  { id: 5, label: "Dr", value: "Dr" },
  { id: 6, label: "Lady", value: "Lady" },
  { id: 7, label: "Rev", value: "Rev" },
  { id: 8, label: "Miss", value: "Miss" },
  { id: 9, label: "Lt", value: "Lt" },
  { id: 10, label: "Mast", value: "Mast" },
  { id: 11, label: "Wing Commander", value: "Wing Commander" },
  { id: 12, label: "Phd", value: "Phd" },
  { id: 13, label: "Maj", value: "Maj" },
  { id: 14, label: "Gen", value: "Gen" },
  { id: 15, label: "Sist", value: "Sist" },
  { id: 16, label: "Capt", value: "Capt" },
  { id: 17, label: "Hon", value: "Hon" },
  { id: 18, label: "Justice", value: "Justice" },
  { id: 19, label: "Col", value: "Col" },
  { id: 20, label: "Shri", value: "Shri" },
  { id: 21, label: "Adv", value: "Adv" },
  { id: 22, label: "Mis", value: "Mis" },
  { id: 23, label: "Cust", value: "Cust" },
  { id: 24, label: "Mst", value: "Mst" },
  { id: 25, label: "Md", value: "Md" },
  { id: 26, label: "Major", value: "Major" },
  { id: 28, label: "Brig", value: "Brig" },
  { id: 29, label: "Mstr", value: "Mstr" },
  { id: 30, label: "Others", value: "Others" },
];

export const GENDER = [
  { id: 1, value: "male", label: "Male" },
  { id: 2, value: "female", label: "Female" },
  { id: 3, value: "others", label: "Others" },
];

export const NATIONALITY = [
  { id: 1, value: "Indian", label: "Indian" },
  { id: 2, value: "Others", label: "Others" },
];
export const NATIONALITY_RESERVE = [
  { id: 1, value: "Indian", label: "Indian" },
  { id: 2, value: "Foreign National", label: "Foreign National" },
];

export const OPERATIVE_STATUS_TELEMER = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Operated", label: "Operated" },
  { id: 2, value: "Un-operated", label: "Un-operated" },
  { id: 3, value: "NA", label: "NA" },
];

export const OPERATIVE_STATUS = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Operated", label: "Operated" },
  { id: 2, value: "Unoperated", label: "Unoperated" },
];

export const TYPE_OF_SURGERY = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Hysterectomy", label: "Hysterectomy" },
  { id: 2, value: "Myomectomy", label: "Myomectomy" },
  { id: 3, value: "Unilateral", label: "Unilateral" },
  { id: 4, value: "Bilateral", label: "Bilateral" },
  { id: 5, value: "Unilateral removal", label: "Unilateral removal" },
];

export const TREATMENT_STATUS_TELEMER = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Cured", label: "Cured" },
  { id: 2, value: "Not Cured", label: "Not Cured" },
];
export const TREATMENT_STATUS = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Cured", label: "Cured" },
  { id: 2, value: "Not cured", label: "Not cured" },
];

export const COMPLICATIONS = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Yes", label: "Yes" },
  { id: 2, value: "No", label: "No" },
];

export const MEDICATION_HISTORY = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Regular", label: "Regular" },
  { id: 2, value: "Irregular", label: "Irregular" },
];
export const MEDICATION_HISTORY_TELEMER = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Regular", label: "Regular" },
  { id: 2, value: "Irregular", label: "Irregular" },
  { id: 3, value: "Completed", label: "Completed" },
  { id: 4, value: "Not on Treatment", label: "Not on Treatment" },
];

export const PROGRESS = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Controlled", label: "Controlled" },
  { id: 2, value: "Uncontrolled", label: "Uncontrolled" },
];

export const MODE_OF_MEDICATION_TELEMER = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Oral", label: "Oral" },
  { id: 2, value: "Injectable", label: "Injectable" },
  { id: 3, value: "Oral + Injectable", label: "Oral + Injectable" },
  { id: 4, value: "NA", label: "NA" },
];
export const MODE_OF_MEDICATION = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Oral", label: "Oral" },
  { id: 2, value: "Injectable", label: "Injectable" },
  { id: 3, value: "Oral + Injectable", label: "Oral + Injectable" },
];
export const MODE_OF_MEDICATION_STEROIDS = [
  { id: 0, label: "Select value", value: "" },
  { id: 1, value: "Oral", label: "Oral" },
  { id: 2, value: "Injectable", label: "Injectable" },
  { id: 3, value: "Oral + Injectable", label: "Oral + Injectable" },
  { id: 4, value: "Inhaler/Steroids", label: "Inhaler/Steroids" },
];

export const NOMINEE_RELATIONSHIP = [
  { id: 0, label: "Self", value: "Self" },
  { id: 1, label: "Spouse", value: "Spouse" },
  { id: 2, label: "Husband", value: "Husband" },
  { id: 3, label: "Wife", value: "Wife" },
  { id: 4, label: "Son", value: "Son" },
  { id: 5, label: "Daughter", value: "Daughter" },
  { id: 6, label: "Mother", value: "Mother" },
  { id: 7, label: "Father", value: "Father" },
  { id: 8, label: "Brother", value: "Brother" },
  { id: 9, label: "Sister", value: "Sister" },
  { id: 10, label: "Grand Daughter", value: "Grand Daughter" },
  { id: 11, label: "Grand Son", value: "Grand Son" },
];

export const DISABILITY_RELATIONSHIP = [
  ...NOMINEE_RELATIONSHIP,
  { id: 12, label: "Friend", value: "Friend" },
  { id: 13, label: "Others", value: "Others" },
];

export const TELEMER_RELATIONSHIP = [
  { id: 0, label: "Self", value: "Self" },
  { id: 1, label: "Spouse", value: "Spouse" },
  { id: 2, label: "Son", value: "Son" },
  { id: 3, label: "Daughter", value: "Daughter" },
  { id: 4, label: "Mother", value: "Mother" },
  { id: 5, label: "Father", value: "Father" },
  { id: 6, label: "Father in law", value: "Father in law" },
  { id: 7, label: "Mother in law", value: "Mother in law" },
  { id: 8, label: "Grand Father", value: "Grand Father" },
  { id: 9, label: "Grand Mother", value: "Grand Mother" },
];

export const APPOINTEE_RELATION = [
  { id: 1, label: "Mother", value: "Mother" },
  { id: 2, label: "Son", value: "Son" },
  { id: 3, label: "Father", value: "Father" },
  { id: 4, label: "Daughter", value: "Daughter" },
  { id: 5, label: "Husband", value: "Husband" },
  { id: 6, label: "Spouse", value: "Spouse" },
  { id: 7, label: "Brother", value: "Brother" },
  { id: 8, label: "Sister", value: "Sister" },
];

export const MARITAL_STATUS = [
  { id: 1, label: "Single", value: "Single" },
  { id: 2, label: "Married", value: "Married" },
  { id: 3, label: "Divorced", value: "Divorced" },
  { id: 4, label: "Widowed", value: "Widowed" },
  { id: 5, label: "Others", value: "Others" },
];
export const OCCUPATION = [
  { id: 1, label: "Salaried", value: "Salaried" },
  { id: 2, label: "Self Employed", value: "Self Employed" },
  { id: 3, label: "Unemployed", value: "Unemployed" },
  {
    id: 4,
    label: "Retired/Homemaker/Student",
    value: "Retired/Homemaker/Student",
  },
];
export const COPS_DECISIONS = [
  { id: 1, label: "Accept", value: "Accept" },
  { id: 2, label: "Discrepancy", value: "Discrepancy" },
  { id: 3, label: "Reject", value: "Reject" },
];

export const UW_DECISIONS = [
  { id: 1, label: "Accept", value: "Accept" },
  { id: 2, label: "Reject", value: "Reject" },
  {
    id: 3,
    label: "Additional Info Required",
    value: "AdditionalInfoRequired",
  },
  { id: 4, label: "Accept With Loading", value: "AcceptWithLoading" },
  { id: 5, label: "Accept With Exclusion", value: "AcceptWithExclusion" },
  {
    id: 6,
    label: "Accept With Loading And Exclusion",
    value: "AcceptWithExclusionAndLoading",
  },
  { id: 7, label: "Refer To TeleMER", value: "ReferToTeleMER" },
  { id: 8, label: "Refer To PPC", value: "ReferToPPC" },
];
export const UW_DECISIONS_PA = [
  { id: 1, label: "Accept", value: "Accept" },
  { id: 2, label: "Reject", value: "Reject" },
  {
    id: 3,
    label: "Additional Info Required",
    value: "AdditionalInfoRequired",
  },
];

export const SUPER_USER_DECISION = [
  { id: 1, label: "Accept", value: "Accept" },
  { id: 2, label: "Reject", value: "Reject" },
];

export const EXCLUSION_PERIOD = [
  { id: 1, label: "1 year", value: "1" },
  { id: 2, label: "2 years", value: "2" },
  { id: 3, label: "3 years", value: "3" },
  { id: 5, label: "Permanent", value: "permanent" },
];
export const REJECT_REASON = [
  {
    id: 1,
    value: "1st or 3rd trimester of pregnancy",
    label: "1st or 3rd trimester of pregnancy",
  },
  { id: 2, value: "Active infection", label: "Active infection" },
  { id: 3, value: "Alcohol", label: "Alcohol" },
  {
    id: 4,
    value: "Alcohol related disorders",
    label: "Alcohol related disorders",
  },
  { id: 5, value: "Angioplasty", label: "Angioplasty" },
  { id: 6, value: "Ankylosing spondylitis", label: "Ankylosing Spondylitis" },
  { id: 7, value: "Arthritis", label: "Arthritis" },
  { id: 8, value: "Auto Immune Diseases", label: "Auto Immune Diseases" },
  { id: 9, value: "Bipolar disorder", label: "Bipolar disorder" },
  { id: 10, value: "Bleeding disorders", label: "Bleeding disorders" },
  { id: 11, value: "Cancer", label: "Cancer" },
  { id: 12, value: "Cardiac ailment", label: "Cardiac ailment" },
  { id: 13, value: "Cardiac Surgeries", label: "Cardiac Surgeries" },
  {
    id: 14,
    value: "Cardiovascular disorder",
    label: "Cardiovascular disorder",
  },
  {
    id: 15,
    value: "Chronic Obstructive Pulmonary Disease",
    label: "Chronic Obstructive Pulmonary Disease",
  },
  {
    id: 16,
    value: "Conduction Abnormalities of Cardiac System",
    label: "Conduction Abnormalities of Cardiac System",
  },
  {
    id: 17,
    value: "Congenital disorders of Renal System",
    label: "Congenital disorders of Renal System",
  },
  {
    id: 18,
    value: "Congestive Heart Failure",
    label: "Congestive Heart Failure",
  },
  {
    id: 19,
    value: "Coronary Artery Disease",
    label: "Coronary Artery Disease",
  },
  { id: 20, value: "Coronary Bypass", label: "Coronary Bypass" },
  { id: 21, value: "Crohn’s disease", label: "Crohn’s disease" },
  { id: 22, value: "Deep Vein Thrombosis", label: "Deep Vein Thrombosis" },
  {
    id: 23,
    value: "Diabetes, Asthma & Dyslipidemia",
    label: "Diabetes, Asthma & Dyslipidemia",
  },
  {
    id: 24,
    value: "Diabetes, Hypertension & Dyslipidemia",
    label: "Diabetes, Hypertension & Dyslipidemia",
  },
  {
    id: 25,
    value: "Diabetes, Renal Calculi & Dyslipidemia",
    label: "Diabetes, Renal Calculi & Dyslipidemia",
  },
  {
    id: 26,
    value: "Early onset of diabetes",
    label: "Early onset of diabetes",
  },
  {
    id: 27,
    value: "Early onset of hypertension",
    label: "Early onset of hypertension",
  },
  {
    id: 28,
    value: "Elevated Blood Pressure",
    label: "Elevated Blood Pressure",
  },
  { id: 29, value: "Epilepsy", label: "Epilepsy" },
  { id: 30, value: "Fatty Liver", label: "Fatty Liver" },
  { id: 31, value: "G6PD deficiency", label: "G6PD deficiency" },
  { id: 32, value: "Genetic Disorders", label: "Genetic Disorders" },
  { id: 33, value: "Genital Herpes", label: "Genital Herpes" },
  { id: 34, value: "Glaucoma", label: "Glaucoma" },
  { id: 35, value: "Gout", label: "Gout" },
  {
    id: 36,
    value: "Head Injury- haemorrhage",
    label: "Head Injury- haemorrhage",
  },
  { id: 37, value: "Heart Attack", label: "Heart Attack" },
  { id: 38, value: "Hepatitis B", label: "Hepatitis B" },
  { id: 39, value: "Hepatitis C", label: "Hepatitis C" },
  { id: 40, value: "Hiatus Hernia", label: "Hiatus Hernia" },
  { id: 41, value: "Higher disability %", label: "Higher disability %" },
  { id: 42, value: "Hyperthyroidism", label: "Hyperthyroidism" },
  { id: 43, value: "Hyperuricemia", label: "Hyperuricemia" },
  {
    id: 44,
    value: "Insulin dependent diabetes",
    label: "Insulin dependent diabetes",
  },
  { id: 45, value: "Liver cirrhosis", label: "Liver cirrhosis" },
  {
    id: 46,
    value: "Long standing h/o diabetes",
    label: "Long standing h/o diabetes",
  },
  {
    id: 47,
    value: "Long standing h/o hypertension",
    label: "Long standing h/o hypertension",
  },
  { id: 48, value: "Malignancy or Cancer", label: "Malignancy or Cancer" },
  { id: 49, value: "Malignant tumor", label: "Malignant tumor" },
  { id: 50, value: "Multiple Sclerosis", label: "Multiple Sclerosis" },
  { id: 51, value: "Nephrectomy", label: "Nephrectomy" },
  {
    id: 52,
    value: "Nervous system disorder",
    label: "Nervous system disorder",
  },
  { id: 53, value: "Osteoarthritis ", label: "Osteoarthritis " },
  { id: 54, value: "Osteoporosis", label: "Osteoporosis" },
  { id: 55, value: "Others", label: "Others" },
  {
    id: 56,
    value: "Pace maker implantation",
    label: "Pace maker implantation",
  },
  { id: 57, value: "Pancreatitis", label: "Pancreatitis" },
  { id: 58, value: "Paralysis", label: "Paralysis" },
  {
    id: 59,
    value: "Personal medical history",
    label: "Personal medical history",
  },
  { id: 60, value: "Pneumonia", label: "Pneumonia" },
  { id: 61, value: "Pulmonary Hypertension", label: "Pulmonary Hypertension" },
  {
    id: 62,
    value: "Recent history of hospitalisation (within last 3 months)",
    label: "Recent history of hospitalisation (within last 3 months)",
  },
  { id: 63, value: "Recurrent TB", label: "Recurrent TB" },
  { id: 64, value: "Renal donor", label: "Renal donor" },
  {
    id: 65,
    value:
      "Renal failure/ Chronic renal disorder/ ESRD (End stage renal disorder)",
    label:
      "Renal failure/ Chronic renal disorder/ ESRD (End stage renal disorder)",
  },
  { id: 66, value: "Renal Transplant", label: "Renal Transplant" },
  { id: 67, value: "Retinal detachment", label: "Retinal detachment" },
  { id: 68, value: "Rheumatoid Arthritis ", label: "Rheumatoid Arthritis " },
  { id: 69, value: "Schizophrenia", label: "Schizophrenia" },
  { id: 70, value: "Seizure", label: "Seizure" },
  {
    id: 71,
    value: "Stroke/ Cerebro Vascular Accident",
    label: "Stroke/ Cerebro Vascular Accident",
  },
  { id: 72, value: "Subnormal 2D-echo", label: "Subnormal 2D-echo" },
  { id: 73, value: "Subnormal CT-scan", label: "Subnormal CT-scan" },
  { id: 74, value: "Subnormal ECG", label: "Subnormal ECG" },
  { id: 75, value: "Subnormal high BMI", label: "Subnormal high BMI" },
  {
    id: 76,
    value: "Subnormal Kidney Function Test",
    label: "Subnormal Kidney Function Test",
  },
  {
    id: 77,
    value: "Subnormal Liver Function Test",
    label: "Subnormal Liver Function Test",
  },
  { id: 78, value: "Subnormal low BMI", label: "Subnormal low BMI" },
  { id: 79, value: "Subnormal MRI", label: "Subnormal MRI" },
  { id: 80, value: "Subnormal USG", label: "Subnormal USG" },
  {
    id: 81,
    value: "Subnormal value of FBS & HBA1C",
    label: "Subnormal value of FBS & HBA1C",
  },
  { id: 82, value: "Substance abuse", label: "Substance abuse" },
  { id: 83, value: "Thalessemia (major)", label: "Thalessemia (major)" },
  { id: 84, value: "Tobacco", label: "Tobacco" },
  { id: 85, value: "Tuberculosis", label: "Tuberculosis" },
  { id: 86, value: "Ulcer", label: "Ulcer" },
  { id: 87, value: "Ulcerative Colitis", label: "Ulcerative Colitis" },
  { id: 88, value: "Unoperated cataract", label: "Unoperated cataract" },
  {
    id: 89,
    value: "Unoperated Gall bladder stone",
    label: "Unoperated Gall bladder stone",
  },
  { id: 90, value: "Unoperated Hernia", label: "Unoperated Hernia" },
  {
    id: 91,
    value: "Unoperated uterus fibroids",
    label: "Unoperated uterus fibroids",
  },
  {
    id: 92,
    value: "Unoperated varicose vein",
    label: "Unoperated varicose vein",
  },
  { id: 93, value: "Urethral stricture", label: "Urethral stricture" },
  {
    id: 94,
    value: "Rejected by Auto-underwriting",
    label: "Rejected by Auto-underwriting",
  },
];
export const ADDITIONAL_INFO_REQUIRED = [
  { id: 1, value: "Discharge card", label: "Discharge card" },
  { id: 2, value: "Investigation reports", label: "Investigation reports" },
  { id: 3, value: "Follow up reports", label: "Follow up reports" },
  { id: 4, value: "Treatment details", label: "Treatment details" },
  {
    id: 5,
    value: "Doctor consultation papers",
    label: "Doctor consultation papers",
  },
  { id: 6, value: "Disability certificate", label: "Disability certificate" },
  {
    id: 7,
    value:
      "Certificate from treating physician confirming diangnosis and current",
    label:
      "Certificate from treating physician confirming diangnosis and current",
  },
  { id: 8, value: "Recent USG Reports", label: "Recent USG Reports" },
];
export const ADDITIONAL_INFO_REQUIRED_PA = [
  { id: 1, label: "Income Documents", value: "Income Documents" },
  { id: 2, label: "Medical Documents", value: "Medical Documents" },
  {
    id: 3,
    label: "Other Insurance documents",
    value: "Other Insurance documents",
  },
  { id: 4, label: "Other documents", value: "Other documents" },
];

export const ALCOHOL_TYPE = [
  { id: 1, value: "Beer", label: "Beer" },
  { id: 2, value: "Wine", label: "Wine" },
  {
    id: 3,
    value: "Hard Liquor",
    label: "Hard Liquor",
  },
];

export const LIFESTYLE_FREQUENCY = [
  { id: 1, value: "Daily", label: "Daily" },
  {
    id: 2,
    value: "Weekly",
    label: "Weekly",
  },
];

//list of  Medical disease
export const NAME_OF_DISEASE2 = [
  { id: 0, label: "Angina", value: "AG1" },
  { id: 1, label: "Ankylosing Spondylosis", value: "AS1" },
  { id: 2, label: "Appendicitis", value: "AP1" },
  { id: 3, label: "Artherosclerosis", value: "AG2" },
  // { id: 4, label: "Asthma", value: "AS2" },
  { id: 5, label: "Autoimmune disorder", value: "AI1" },
  { id: 6, label: "Bell's Palsy", value: "BP2" },
  { id: 7, label: "Benign prostatic enlargement", value: "BP1" },
  { id: 8, label: "Cancer", value: "CA1" },
  { id: 9, label: "Cholecystitis", value: "CH1" },
  { id: 10, label: "Cholelithiasis", value: "CH2" },
  { id: 11, label: "Chronic Obstructive Pulmonary Disease", value: "CO1" },
  { id: 12, label: "Coronary Artery Diseases", value: "CD1" },
  { id: 13, label: "COVID 19", value: "CV19" },
  // { id: 14, label: "Diabetes Mellitus", value: "DM1" },
  { id: 15, label: "Deep Vein Thrombosis", value: "DV1" },
  { id: 16, label: "Deviated nasal septum (DNS)", value: "DN1" },
  { id: 17, label: "Epilepsy", value: "EP1" },
  { id: 18, label: "Fatty liver grade 1", value: "FT1" },
  { id: 19, label: "Fever", value: "FV1" },
  { id: 20, label: "Fibroid uterus", value: "FU1" },
  { id: 21, label: "Glaucoma", value: "GL1" },
  { id: 22, label: "Goiter", value: "GO1" },
  { id: 23, label: "Heart attack", value: "HA1" },
  // { id: 24, label: "High Cholestrol", value: "DM6" },
  // { id: 25, label: "Hypertension", value: "DM2" },
  { id: 26, label: "Hypotension", value: "DM3" },
  { id: 27, label: "Hyperthyroid", value: "DM5" },
  { id: 28, label: "Hypothyroid", value: "DM4" },
  { id: 29, label: "Ischemic heart disease", value: "IHD1" },
  { id: 30, label: "Leaukemia", value: "LK1" },
  { id: 31, label: "Migraine", value: "MG1" },
  { id: 32, label: "Osteoarthritis", value: "OS1" },
  { id: 33, label: "Ovarian cyst", value: "OC1" },
  { id: 34, label: "Pancreatitis", value: "PN2" },
  { id: 35, label: "paralysis", value: "PR1" },
  { id: 36, label: "Pilonidal Sinus", value: "PS1" },
  { id: 37, label: "Polycystic ovary syndrome (PCOD)", value: "PCOD1" },
  { id: 38, label: "Pregnancy", value: "PG1" },
  { id: 39, label: "Pulmonary Embolism", value: "PE1" },
  { id: 40, label: "Renal stones", value: "RS1" },
  { id: 41, label: "Sinusitis", value: "SI1" },
  { id: 42, label: "Spinal disorder", value: "SD1" },
  { id: 43, label: "Stroke", value: "ST1" },
  { id: 44, label: "Systemic lupus erythematosus (SLE)", value: "SLE1" },
  { id: 45, label: "Ulcer", value: "UL1" },
  { id: 46, label: "Ulcerative colitis", value: "UL2" },
  { id: 47, label: "unoperated Arthritis ", value: "AR1" },
  { id: 48, label: "Thalassemia Major", value: "TM1" },
  { id: 49, label: "Tonsillitis", value: "TN1" },
  { id: 50, label: "Varicose veins", value: "VV1" },
  { id: 51, label: "Vertigo", value: "VT1" },
  { id: 52, label: "Others", value: "OTH" },
  { id: 53, label: "Arthritis", value: "AR2" },
  { id: 54, label: "Pregnancy - 1st trimester", value: "PG2" },
  { id: 55, label: "Pregnancy - 3rd trimester", value: "PG3" },
];

// export const NAME_OF_DISEASE_4 = () => {
//   let newDiseases = [...NAME_OF_DISEASE2];
//   newDiseases.splice(-1);
//   return newDiseases;
// };

//list of Surgical disease
export const NAME_OF_DISEASE = [
  { id: 0, label: "Angioplasty", value: "AG1" },
  { id: 1, label: "Appendectomy", value: "AP1" },
  { id: 2, label: "Arthritis", value: "AR1" },
  { id: 3, label: "Brain surgery", value: "BS1" },
  { id: 4, label: "Cancer", value: "CN1" },
  { id: 5, label: "Cataract - Both eyes", value: "DS4" },
  { id: 6, label: "Cataract - Congenital", value: "DS5" },
  { id: 7, label: "Cataract - One eye", value: "DS3" },
  { id: 8, label: "Calculus - Renal/Urinary Tract", value: "DS1" },
  { id: 9, label: "Cholecystectomy", value: "CL1" },
  { id: 10, label: "Coronary artery bypass surgery", value: "CA1" },
  { id: 11, label: "Deep Vein Thrombosis", value: "DV1" },
  { id: 12, label: "Deviated nasal septum (DNS)", value: "DV2" },
  { id: 13, label: "Fracture & implant", value: "FI1" },
  { id: 14, label: "Fracture & surgery", value: "FI2" },
  { id: 15, label: "Fibroid Uterus", value: "DS2" },
  { id: 16, label: "Glaucoma", value: "GL1" },
  { id: 17, label: "Goiter", value: "GO1" },
  { id: 18, label: "Haemorrhoids / fissure / fistula", value: "DS7" },
  { id: 19, label: "Hernia", value: "DS8" },
  { id: 20, label: "Hysterectomy", value: "DS9" },
  { id: 21, label: "Ovarian cyst", value: "OC1" },
  { id: 22, label: "Pilonidal Sinus", value: "PS1" },
  { id: 23, label: "Renal stones surgery", value: "RS1" },
  { id: 24, label: "Rheumatoid Arthritis", value: "RA1" },
  { id: 25, label: "Spinal surgery", value: "SS1" },
  { id: 26, label: "Thyroid removal", value: "TR1" },
  { id: 27, label: "Tonsillitis", value: "DS6" },
  { id: 28, label: "Valvular diseases", value: "VD1" },
  { id: 29, label: "Inguinal Hernia", value: "IH1" },
  { id: 30, label: "Umbilical Hernia", value: "UH1" },
  { id: 31, label: "Ventral Hernia", value: "VH1" },
  { id: 32, label: "Others", value: "OTH" },
];

export const DECLINE_DISEASE = [
  { id: -1, label: "Select Disease", value: "" },
  { id: 0, label: "Acute Coronary Syndrome - ACS", value: "DD2" },
  { id: 1, label: "Ankylosing Spondylosis", value: "DD6" },
  {
    id: 2,
    label: "Auto Immune Diseases",
    value: "DD9",
  },
  { id: 3, label: "Bariatric Surgery", value: "DD10" },
  { id: 4, label: "Bipolar Disorder", value: "DD11" },
  { id: 5, label: "Bleeding disorders", value: "DD12" },
  { id: 6, label: "Brain Infarct", value: "DD13" },
  { id: 7, label: "Brain surgery", value: "DD14" },
  { id: 8, label: "Cancer", value: "DD16" },
  { id: 9, label: "Cerebrovascular Accident (Stroke)", value: "DD20" },
  { id: 10, label: "Chronic / Recurrent Bronchitis ", value: "DD21" },
  { id: 11, label: "Chronic / Recurrent Pneumonia", value: "DD22" },
  { id: 12, label: "Chronic Heart Disease", value: "DD24" },
  { id: 13, label: "Chronic Kidney Disease", value: "DD25" },
  { id: 14, label: "Chronic Liver Disease", value: "DD26" },
  {
    id: 15,
    label: "Chronic Obstructive Pulmonary Disease (COPD)",
    value: "DD27",
  },
  { id: 16, label: "Chronic Pancreatitis", value: "DD118" },
  { id: 17, label: "Cirrhosis of liver", value: "DD29" },
  { id: 18, label: "Congestive Heart Failure", value: "DD31" },
  { id: 19, label: "Coronary Artery Disease", value: "DD33" },
  { id: 20, label: "Coronary Bypass", value: "DD34" },
  { id: 21, label: "Crohn’s disease", value: "DD35" },
  { id: 22, label: "Deep Vein thrombosis", value: "DD37" },
  { id: 23, label: "Diabetes Incipidus", value: "DD39" },
  {
    id: 24,
    label: "Diabetes Mellitus and on insulin medications",
    value: "DD40",
  },
  { id: 25, label: "Diabetic foot", value: "DD41" },
  { id: 26, label: "Duodenal and stomach ulcers", value: "DD42" },
  { id: 27, label: "G6PD deficiency", value: "DD45" },
  { id: 28, label: "Glaucoma", value: "DD46" },
  { id: 29, label: "Goiter", value: "DD47" },
  { id: 30, label: "Gonorrhea", value: "DD48" },
  { id: 31, label: "Guillain-Barré syndrome (GBS)", value: "DD49" },
  { id: 32, label: "Hansen's disease (Leprosy)", value: "DD50" },
  { id: 33, label: "Heart Attack", value: "DD51" },
  { id: 34, label: "Heart failure", value: "DD52" },
  { id: 35, label: "Hemiparesis/ Hemiplegia/ Paralysis", value: "DD54" },
  { id: 36, label: "Hepatitis B", value: "DD55" },
  { id: 37, label: "Hepatitis C", value: "DD56" },
  { id: 38, label: "Hiatus Hernia", value: "DD57" },
  { id: 39, label: "HLA B27 positive", value: "DD58" },
  { id: 40, label: "Hydrocephalous", value: "DD59" },
  { id: 41, label: "Hyperthyroidism", value: "DD60" },
  { id: 42, label: "Ischemic heart disease - IHD", value: "DD61" },
  { id: 43, label: "Kidney donar", value: "DD119" },
  { id: 44, label: "Kidney failure (Renal failure)", value: "DD62" },
  { id: 45, label: "Kidney surgery - Nephrectomy", value: "DD63" },
  { id: 46, label: "Kidney transplantation", value: "DD64" },
  { id: 47, label: "Leukaemia", value: "DD65" },
  { id: 48, label: "Liver donor", value: "DD120" },
  { id: 49, label: "Lung Surgery", value: "DD66" },
  { id: 50, label: "Meningitis - Bacterial", value: "DD68" },
  { id: 51, label: "Mental Retardation", value: "DD69" },
  {
    id: 52,
    label: "Miliary Tuberculosis",
    value: "DD70",
  },
  { id: 53, label: "Motor Neuron Disorders", value: "DD71" },
  { id: 54, label: "Multinodular Goitre", value: "DD72" },
  { id: 55, label: "Multiple Sclerosis", value: "DD73" },
  { id: 56, label: "Muscular dystrophies", value: "DD74" },
  { id: 57, label: "Myasthenia gravis", value: "DD75" },
  { id: 58, label: "Myocardial Infarction", value: "DD76" },
  { id: 59, label: "Nephrotic Syndrome", value: "DD79" },
  { id: 60, label: "Neurcystocercosis", value: "DD80" },
  { id: 61, label: "Obstructive Sleep Apnoea (OSA)", value: "DD81" },
  { id: 62, label: "Osteoclastoma", value: "DD83" },
  { id: 63, label: "Osteomyelitis (OM)", value: "DD84" },
  { id: 64, label: "Osteosarcoma", value: "DD85" },
  { id: 65, label: "Pancreatitis", value: "DD87" },
  { id: 66, label: "Paralysis", value: "DD88" },
  { id: 67, label: "Parkinson's disease", value: "DD89" },
  { id: 68, label: "Peripheral vascular disease (PVD)", value: "DD90" },
  { id: 69, label: "Pilonidal Sinus - unoperated", value: "DD121" },
  { id: 70, label: "Polyarthritis", value: "DD91" },
  { id: 71, label: "Portal hypertension", value: "DD92" },
  { id: 72, label: "Portal vein obstruction", value: "DD93" },
  { id: 73, label: "Portal vein thrombosis", value: "DD94" },
  { id: 74, label: "Prolapsed Uterus - Unoperated ", value: "DD96" },
  { id: 75, label: "Psoriatic Arthritis", value: "DD97" },
  { id: 76, label: "Pulmonary Embolism", value: "DD98" },
  { id: 77, label: "Pulmonary Hypertension", value: "DD99" },
  { id: 78, label: "Recurrent TB", value: "DD100" },
  { id: 79, label: "Renal Transplant", value: "DD102" },
  { id: 80, label: "Rheumatoid Arthritis", value: "DD103" },
  { id: 81, label: "Right/ Left Bundle branch block", value: "DD104" },
  { id: 82, label: "Schizophrenia", value: "DD106" },
  { id: 83, label: "Schwannoma", value: "DD107" },
  { id: 84, label: "Septic arthritis", value: "DD108" },
  {
    id: 85,
    label: "Subarachnoid haemorhage (SAH)/ Subdural Haemorhage (SDH)",
    value: "DD111",
  },
  { id: 86, label: "Syphillis ", value: "DD112" },
  { id: 87, label: "Systemic lupus erythematosus (SLE)", value: "DD122" },
  { id: 88, label: "Thalassemia Major", value: "DD113" },
  { id: 89, label: "Transverse Myelitis", value: "DD114" },
  {
    id: 90,
    label:
      "Trasient Ischemic attack - TIA/ Cerebrovascular Accident - CVA / Stroke",
    value: "DD115",
  },
  { id: 91, label: "Ulcerative colitis", value: "DD116" },
];
export const CUSTOMER_TYPE = [
  { id: 1, value: "New Customer", label: "New Customer" },
  { id: 2, value: "Existing Customer", label: "Existing Customer" },
];
export const EXCLUSION_DISEASE = [
  { id: 1, value: "Abdominal Hernia", label: "Abdominal Hernia" },
  { id: 2, value: "Abscess", label: "Abscess" },
  { id: 3, value: "ACL tear Knee", label: "ACL tear Knee" },
  { id: 4, value: "Active infection", label: "Active infection" },
  { id: 5, value: "Anemia", label: "Anemia" },
  { id: 6, value: "Angioplasty", label: "Angioplasty" },
  { id: 7, value: "Ankylosing spondylitis", label: "Ankylosing spondylitis" },
  { id: 8, value: "Anxiety", label: "Anxiety" },
  { id: 9, value: "Arthrosis", label: "Arthrosis" },
  { id: 10, value: "Asthma", label: "Asthma" },
  { id: 11, value: "Autoimmune disease", label: "Autoimmune disease" },
  { id: 12, value: "Avascular Necrosis", label: "Avascular Necrosis" },
  {
    id: 13,
    value: "Benign Prostate enlargement",
    label: "Benign Prostate enlargement",
  },
  { id: 14, value: "Bipolar disorder", label: "Bipolar disorder" },
  { id: 15, value: "Bleeding disorder", label: "Bleeding disorder" },
  {
    id: 16,
    value: "BPH (Benign Prostatic Hyperplasia)",
    label: "BPH (Benign Prostatic Hyperplasia)",
  },
  { id: 17, value: "Calculus", label: "Calculus" },
  { id: 18, value: "Cancer", label: "Cancer" },
  {
    id: 19,
    value: "Cardiovascular disorder",
    label: "Cardiovascular disorder",
  },
  { id: 20, value: "Cataract", label: "Cataract" },
  { id: 21, value: "Cataract - Congenital", label: "Cataract - Congenital" },
  {
    id: 22,
    value: "Cerebrovascular disorder",
    label: "Cerebrovascular disorder",
  },
  { id: 23, value: "Chronic Renal Disease", label: "Chronic Renal Disease" },
  { id: 24, value: "COPD", label: "COPD" },
  { id: 25, value: "Crohn's Disease", label: "Crohn's Disease" },
  { id: 26, value: "Deafness", label: "Deafness" },
  { id: 27, value: "Depression", label: "Depression" },
  {
    id: 28,
    value: "Dermatological disorder",
    label: "Dermatological disorder",
  },
  { id: 29, value: "Deviated Nasal Septum", label: "Deviated Nasal Septum" },
  { id: 30, value: "Diabetes", label: "Diabetes" },
  { id: 31, value: "Diabetes Mellitus", label: "Diabetes Mellitus" },
  { id: 32, value: "Dyslipidemia", label: "Dyslipidemia" },
  { id: 33, value: "Early Onset Diabetes", label: "Early Onset Diabetes" },
  {
    id: 34,
    value: "Early Onset Hypertension",
    label: "Early Onset Hypertension",
  },
  {
    id: 35,
    value: "Elevated Blood Pressure",
    label: "Elevated Blood Pressure",
  },
  { id: 36, value: "Endocrine Disorder", label: "Endocrine Disorder" },
  { id: 37, value: "ENT disorder", label: "ENT disorder" },
  { id: 38, value: "Epilepsy", label: "Epilepsy" },
  { id: 39, value: "Eye disorders", label: "Eye disorders" },
  { id: 40, value: "Fatty Liver", label: "Fatty Liver" },
  { id: 41, value: "Fibroadenoma Breast", label: "Fibroadenoma Breast" },
  { id: 42, value: "Fibroid Uterus", label: "Fibroid Uterus" },
  { id: 43, value: "Fissue", label: "Fissue" },
  { id: 44, value: "Fistula", label: "Fistula" },
  { id: 45, value: "G6PD deficiency", label: "G6PD deficiency" },
  {
    id: 46,
    value: "Gastrointestinal Disorder",
    label: "Gastrointestinal Disorder",
  },
  { id: 47, value: "Genetic disorder", label: "Genetic disorder" },
  { id: 48, value: "Genitourinary disorder", label: "Genitourinary disorder" },
  { id: 49, value: "Glaucoma", label: "Glaucoma" },
  { id: 50, value: "Gout", label: "Gout" },
  { id: 51, value: "Haemorrhage", label: "Haemorrhage" },
  { id: 52, value: "Haemorrhoids", label: "Haemorrhoids" },
  {
    id: 53,
    value: "Haemorrhoids/Fissure/Fistula",
    label: "Haemorrhoids/Fissure/Fistula",
  },
  { id: 54, value: "Head Injury", label: "Head Injury" },
  { id: 55, value: "Hepatitis B/C", label: "Hepatitis B/C" },
  { id: 56, value: "Hernia", label: "Hernia" },
  { id: 57, value: "Hiatus Hernia", label: "Hiatus Hernia" },
  { id: 58, value: "High Cholesterol", label: "High Cholesterol" },
  {
    id: 59,
    value: "Higher disability percentage",
    label: "Higher disability percentage",
  },
  { id: 60, value: "HIV/AIDS", label: "HIV/AIDS" },
  { id: 61, value: "Hypertension", label: "Hypertension" },
  { id: 62, value: "Hyperthyroid", label: "Hyperthyroid" },
  { id: 63, value: "Hyperthyroidism", label: "Hyperthyroidism" },
  { id: 64, value: "Hyperuricemia", label: "Hyperuricemia" },
  { id: 65, value: "Hypotension", label: "Hypotension" },
  { id: 66, value: "Hypothyroid", label: "Hypothyroid" },
  {
    id: 67,
    value: "Implant/Orthopedic device",
    label: "Implant/Orthopedic device",
  },
  { id: 68, value: "Incisional Hernia", label: "Incisional Hernia" },
  { id: 69, value: "Inguinal Hernia", label: "Inguinal Hernia" },
  {
    id: 70,
    value: "Insulin-dependent diabetes",
    label: "Insulin-dependent diabetes",
  },
  {
    id: 71,
    value: "Intervertebral Disc Disorder",
    label: "Intervertebral Disc Disorder",
  },
  { id: 72, value: "Lichen Planus", label: "Lichen Planus" },
  { id: 73, value: "Liver cirrhosis", label: "Liver cirrhosis" },
  { id: 74, value: "Liver disorder", label: "Liver disorder" },
  { id: 75, value: "Long-standing diabetes", label: "Long-standing diabetes" },
  {
    id: 76,
    value: "Long-standing hypertension",
    label: "Long-standing hypertension",
  },
  { id: 77, value: "MCL tear", label: "MCL tear" },
  { id: 78, value: "Multiple sclerosis", label: "Multiple sclerosis" },
  {
    id: 79,
    value: "Musculoskeletal Disorder",
    label: "Musculoskeletal Disorder",
  },
  { id: 80, value: "Nephrectomy", label: "Nephrectomy" },
  { id: 81, value: "Obesity", label: "Obesity" },
  { id: 82, value: "Osteoarthritis", label: "Osteoarthritis" },
  { id: 83, value: "Osteoporosis", label: "Osteoporosis" },
  { id: 84, value: "Others", label: "Others" },
  { id: 85, value: "Otitis Media", label: "Otitis Media" },
  { id: 86, value: "Ovarian Cyst", label: "Ovarian Cyst" },
  { id: 87, value: "Pacemaker implantation", label: "Pacemaker implantation" },
  { id: 88, value: "Pancreatitis", label: "Pancreatitis" },
  { id: 89, value: "Paralysis", label: "Paralysis" },
  { id: 90, value: "Polio", label: "Polio" },
  {
    id: 91,
    value: "Polycystic Ovarian Disease",
    label: "Polycystic Ovarian Disease",
  },
  { id: 92, value: "Psoariasis", label: "Psoariasis" },
  { id: 93, value: "Pulmonary hypertension", label: "Pulmonary hypertension" },
  { id: 94, value: "Recent Hospitalisation", label: "Recent Hospitalisation" },
  { id: 95, value: "Renal Calculi", label: "Renal Calculi" },
  { id: 96, value: "Renal Cyst", label: "Renal Cyst" },
  { id: 97, value: "Renal disorder", label: "Renal disorder" },
  { id: 98, value: "Renal Failure", label: "Renal Failure" },
  { id: 99, value: "Renal transplant", label: "Renal transplant" },
  { id: 100, value: "Retinal detachment", label: "Retinal detachment" },
  { id: 101, value: "Rheumatoid Arthritis", label: "Rheumatoid Arthritis" },
  { id: 102, value: "Schizophrenia", label: "Schizophrenia" },
  { id: 103, value: "Sinusitis", label: "Sinusitis" },
  { id: 104, value: "Spondylosis", label: "Spondylosis" },
  { id: 105, value: "STDS", label: "STDS" },
  { id: 106, value: "Subnormal 2D echo", label: "Subnormal 2D echo" },
  { id: 107, value: "Substance abuse", label: "Substance abuse" },
  { id: 108, value: "Thalassemia (major)", label: "Thalassemia (major)" },
  { id: 109, value: "Thalessemia (Minor)", label: "Thalessemia (Minor)" },
  { id: 110, value: "Tobacco use", label: "Tobacco use" },
  { id: 111, value: "Tonsilitis", label: "Tonsilitis" },
  { id: 112, value: "Tuberculosis", label: "Tuberculosis" },
  { id: 113, value: "Ulcer", label: "Ulcer" },
  { id: 114, value: "Ulcerative Colitis", label: "Ulcerative Colitis" },
  { id: 115, value: "Umbilical Hernia", label: "Umbilical Hernia" },
  { id: 116, value: "Varicose veins", label: "Varicose veins" },
  { id: 117, value: "Vertigo", label: "Vertigo" },
  {
    id: 118,
    value: "Certain infectious and parasitic diseases",
    label: "Certain infectious and parasitic diseases",
  },
  {
    id: 119,
    value:
      "Diseases of the blood and blood-forming organs and certain disorders involving the immune mechanism",
    label:
      "Diseases of the blood and blood-forming organs and certain disorders involving the immune mechanism",
  },
  {
    id: 120,
    value: "Endocrine, nutritional and metabolic diseases",
    label: "Endocrine, nutritional and metabolic diseases",
  },
  {
    id: 121,
    value: "Mental, Behavioral and Neurodevelopmental disorders",
    label: "Mental, Behavioral and Neurodevelopmental disorders",
  },
  {
    id: 122,
    value: "Diseases of the nervous system",
    label: "Diseases of the nervous system",
  },
  {
    id: 123,
    value: "Diseases of the eye and adnexa",
    label: "Diseases of the eye and adnexa",
  },
  {
    id: 124,
    value: "Diseases of the ear and mastoid process",
    label: "Diseases of the ear and mastoid process",
  },
  {
    id: 125,
    value: "Diseases of the circulatory system",
    label: "Diseases of the circulatory system",
  },
  {
    id: 126,
    value: "Diseases of the respiratory system",
    label: "Diseases of the respiratory system",
  },
  {
    id: 127,
    value: "Diseases of the digestive system",
    label: "Diseases of the digestive system",
  },
  {
    id: 128,
    value: "Diseases of the skin and subcutaneous tissue",
    label: "Diseases of the skin and subcutaneous tissue",
  },
  {
    id: 129,
    value: "Diseases of the musculoskeletal system and connective tissue",
    label: "Diseases of the musculoskeletal system and connective tissue",
  },
  {
    id: 130,
    value: "Diseases of the genitourinary system",
    label: "Diseases of the genitourinary system",
  },
  {
    id: 131,
    value: "Pregnancy, childbirth and the puerperium",
    label: "Pregnancy, childbirth and the puerperium",
  },
  {
    id: 132,
    value: "External causes of morbidity",
    label: "External causes of morbidity",
  },
  {
    id: 133,
    value: "Certain conditions originating in the perinatal period",
    label: "Certain conditions originating in the perinatal period",
  },
  {
    id: 134,
    value: "Factors influencing health status and contact with health services",
    label: "Factors influencing health status and contact with health services",
  },
  {
    id: 135,
    value:
      "Congenital malformations, deformations, chromosomal abnormalities, and genetic disorders",
    label:
      "Congenital malformations, deformations, chromosomal abnormalities, and genetic disorders",
  },
  {
    id: 136,
    value:
      "Symptoms, signs and abnormal clinical and laboratory findings, not elsewhere classified",
    label:
      "Symptoms, signs and abnormal clinical and laboratory findings, not elsewhere classified",
  },
  {
    id: 137,
    value:
      "Injury, poisoning and certain other consequences of external causes",
    label:
      "Injury, poisoning and certain other consequences of external causes",
  },
  {
    id: 138,
    value: "Noninfective enteritis and colitis",
    label: "Noninfective enteritis and colitis",
  },
  {
    id: 139,
    value: "Other diseases of intestines",
    label: "Other diseases of intestines",
  },
  {
    id: 140,
    value: "Disorders of gallbladder, biliary tract and pancreas",
    label: "Disorders of gallbladder, biliary tract and pancreas",
  },
  {
    id: 141,
    value: "Other diseases of the digestive system",
    label: "Other diseases of the digestive system",
  },
  {
    id: 142,
    value: "Other Ligament tear/injury",
    label: "Other Ligament tear/injury",
  },
];

export const DOCUMENT_DOWNLOAD_OPTIONS = [
  { id: 0, label: "Download Policy", value: "POLICY_DOCUMENT" },
  { id: 1, label: "Health Card", value: "HEALTH_CARD" },
  { id: 2, label: "80D", value: "80D" },
];

export const DOCUMENT_DOWNLOAD_OPTIONS_PA = [
  { id: 0, label: "Download Policy", value: "POLICY_DOCUMENT" },
];

export const NAME_OF_DISEASE3 = [
  { id: 0, label: "Diabetes Mellitus", value: "DM1" },
  { id: 1, label: "High Cholestrol", value: "DM6" },
  { id: 2, label: "Hypertension", value: "DM2" },
  // { id: 3, label: "Hypotension", value: "DM3" },
  { id: 6, label: "Asthma", value: "AS2" },
];

export const NAME_OF_DISEASE4 = [
  { id: 4, label: "Hypothyroid", value: "DM4" },
  { id: 7, label: "Hyperthyroid", value: "DM5" },
];

export const INSURER_NAME = [
  {
    id: 1,
    label: "AGRICULTURE INSURANCE CO. OF INDIA LTD.",
    value: "AGRICULTURE INSURANCE CO. OF INDIA LTD.",
  },
  {
    id: 2,
    label: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD",
    value: "BAJAJ ALLIANZ GENERAL INSURANCE CO.LTD",
  },
  {
    id: 3,
    label: "BHARTI AXA GENERAL INSURANCE COMPANY LIMITED",
    value: "BHARTI AXA GENERAL INSURANCE COMPANY LIMITED",
  },
  {
    id: 4,
    label: "CHOLAMANDALAM MS GENERAL INSURANCE CO.LTD.",
    value: "CHOLAMANDALAM MS GENERAL INSURANCE CO.LTD.",
  },
  {
    id: 5,
    label: "DIRECTORATE OF INSURANCE (GIF), GOVT. OF MAHA",
    value: "DIRECTORATE OF INSURANCE (GIF), GOVT. OF MAHA",
  },
  { id: 6, label: "ENDURANCE", value: "ENDURANCE" },
  {
    id: 7,
    label: "EXPORT CREDIT GUARANTEE CORPORATION OF INDIA LTD",
    value: "EXPORT CREDIT GUARANTEE CORPORATION OF INDIA LTD",
  },
  {
    id: 8,
    label: "FUTURE GENERALI INDIA INSURANCE COMPANY LIMITED",
    value: "FUTURE GENERALI INDIA INSURANCE COMPANY LIMITED",
  },
  {
    id: 9,
    label: "GENERAL INSURANCE CORPORATION OF INDIA",
    value: "GENERAL INSURANCE CORPORATION OF INDIA",
  },
  {
    id: 10,
    label: "HDFC ERGO GENERAL INSURANCE CO.LTD.",
    value: "HDFC ERGO GENERAL INSURANCE CO.LTD.",
  },
  {
    id: 11,
    label: "ICICI LOMBARD GENERAL INSURANCE CO. LTD.",
    value: "ICICI LOMBARD GENERAL INSURANCE CO. LTD.",
  },
  {
    id: 12,
    label: "IFFCO TOKIO GENERAL INSURANCE CO. LTD.",
    value: "IFFCO TOKIO GENERAL INSURANCE CO. LTD.",
  },
  {
    id: 13,
    label: "L&T GENERAL INSURANCE CO. LTD.",
    value: "L&T GENERAL INSURANCE CO. LTD.",
  },
  {
    id: 14,
    label: "LIBERTY VIDEOCON GENERAL INSURANCE COMPANY LTD.",
    value: "LIBERTY VIDEOCON GENERAL INSURANCE COMPANY LTD.",
  },
  {
    id: 15,
    label: "MAGMA HDI GENERAL INSURANCE CO LTD",
    value: "MAGMA HDI GENERAL INSURANCE CO LTD",
  },
  { id: 16, label: "MITSUI INSURANCE", value: "MITSUI INSURANCE" },
  {
    id: 17,
    label: "NATIONAL INSURANCE CO.LTD.",
    value: "NATIONAL INSURANCE CO.LTD.",
  },
  {
    id: 18,
    label: "RAHEJA QBE GENERAL INSURANCE COMPANY LIMITED",
    value: "RAHEJA QBE GENERAL INSURANCE COMPANY LIMITED",
  },
  {
    id: 19,
    label: "RELIANCE GENERAL INSURANCE CO.LTD.",
    value: "RELIANCE GENERAL INSURANCE CO.LTD.",
  },
  {
    id: 20,
    label: "ROYAL SUNDARAM ALLIANCE INSURANCE CO.LTD.",
    value: "ROYAL SUNDARAM ALLIANCE INSURANCE CO.LTD.",
  },
  {
    id: 21,
    label: "SBI GENERAL INSURANCE COMPANY LIMITED",
    value: "SBI GENERAL INSURANCE COMPANY LIMITED",
  },
  {
    id: 22,
    label: "STAR HEALTH AND ALLIED INSURANCE COMPANY LIMITED",
    value: "STAR HEALTH AND ALLIED INSURANCE COMPANY LIMITED",
  },
  {
    id: 23,
    label: "TATA AIG GENERAL INSURANCE CO.LTD.",
    value: "TATA AIG GENERAL INSURANCE CO.LTD.",
  },
  {
    id: 24,
    label: "THE GOVT. OF GUJARAT INSURANCE FUND",
    value: "THE GOVT. OF GUJARAT INSURANCE FUND",
  },
  {
    id: 25,
    label: "THE NEW INDIA ASSURANCE CO. LTD.",
    value: "THE NEW INDIA ASSURANCE CO. LTD.",
  },
  {
    id: 26,
    label: "THE ORIENTAL INSURANCE CO. LTD.",
    value: "THE ORIENTAL INSURANCE CO. LTD.",
  },
  {
    id: 27,
    label: "UNITED INDIA INSURANCE CO.LTD.",
    value: "UNITED INDIA INSURANCE CO.LTD.",
  },
  {
    id: 28,
    label: "UNIVERSAL SOMPO GENERAL INSURANCE CO.LTD.",
    value: "UNIVERSAL SOMPO GENERAL INSURANCE CO.LTD.",
  },
  {
    id: 29,
    label: "Maharashtra Government Insurance Fund",
    value: "Maharashtra Government Insurance Fund",
  },
  {
    id: 30,
    label: "HDFC ERGO HEALTH INSURANCE LTD.",
    value: "HDFC ERGO HEALTH INSURANCE LTD.",
  },
  {
    id: 31,
    label: "MANIPALCIGNA HEALTH INSURANCE CO LTD",
    value: "MANIPALCIGNA HEALTH INSURANCE CO LTD",
  },
  {
    id: 32,
    label: "MAX BUPA HEALTH INSURANCE COMPANY LTD.",
    value: "MAX BUPA HEALTH INSURANCE COMPANY LTD.",
  },
  {
    id: 33,
    label: "APOLLO MUNICH (AMHI)",
    value: "APOLLO MUNICH (AMHI)",
  },
  {
    id: 34,
    label: "ACKO General Insurance Ltd",
    value: "ACKO General Insurance Ltd",
  },
  {
    id: 35,
    label: "EDELWEISS GENERAL INSURANCE COMPANY LIMITED",
    value: "EDELWEISS GENERAL INSURANCE COMPANY LIMITED",
  },
  {
    id: 36,
    label: "MAHARASHTRA STATE INSURANCE FUND",
    value: "MAHARASHTRA STATE INSURANCE FUND",
  },
  {
    id: 37,
    label: "LIBERTY GENERAL INSURANCE LTD.",
    value: "LIBERTY GENERAL INSURANCE LTD.",
  },
  {
    id: 38,
    label: "RELIANCE HEALTH INSURANCE LTD.",
    value: "RELIANCE HEALTH INSURANCE LTD.",
  },
  {
    id: 39,
    label: "CARE HEALTH INSURANCE LTD",
    value: "CARE HEALTH INSURANCE LTD",
  },
  {
    id: 40,
    label: "SHRIRAM GENERAL INSURANCE COMPANY LIMITED",
    value: "SHRIRAM GENERAL INSURANCE COMPANY LIMITED",
  },
  {
    id: 41,
    label: "Religare Health Insurance Company Limited",
    value: "Religare Health Insurance Company Limited",
  },
  {
    id: 42,
    label: "KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD",
    value: "KOTAK MAHINDRA GENERAL INSURANCE COMPANY LTD",
  },
  {
    id: 43,
    label: "Aditya Birla Health Insurance Company Limited",
    value: "Aditya Birla Health Insurance Company Limited",
  },
  {
    id: 44,
    label: "CignaTTK Health Insurance Company Limited",
    value: "CignaTTK Health Insurance Company Limited",
  },
  {
    id: 45,
    label: "DHFL COCO GENERAL INSURANCE LIMITED",
    value: "DHFL COCO GENERAL INSURANCE LIMITED",
  },
  {
    id: 46,
    label: "GO DIGIT GENERAL INSURANCE CO LTD",
    value: "GO DIGIT GENERAL INSURANCE CO LTD",
  },
  {
    id: 47,
    label: "NAVI GENERAL INSURANCE LTD",
    value: "NAVI GENERAL INSURANCE LTD",
  },
  {
    id: 48,
    label: "ZURICH KOTAK MAHINDRA GENERAL INSURANCE",
    value: "ZURICH KOTAK MAHINDRA GENERAL INSURANCE",
  },
  {
    id: 49,
    label:
      "Zuno General Insurance Ltd.(formerly known as Edelweiss General Insurance Company Limited)",
    value:
      "Zuno General Insurance Ltd.(formerly known as Edelweiss General Insurance Company Limited)",
  },
  {
    id: 50,
    label: "Bajaj General Insurance Limited",
    value: "Bajaj General Insurance Limited",
  },
  {
    id: 51,
    label:
      "Galaxy Health Insurance Company Limited (formerly known as Galaxy Health and Allied Insurance Co. Ltd)",
    value:
      "Galaxy Health Insurance Company Limited (formerly known as Galaxy Health and Allied Insurance Co. Ltd)",
  },
  {
    id: 52,
    label: "Generali Central Insurance Company Limited",
    value: "Generali Central Insurance Company Limited",
  },
  {
    id: 53,
    label: "Kshema General Insurance Limited",
    value: "Kshema General Insurance Limited",
  },
  {
    id: 54,
    label: "Magma General Insurance Limited",
    value: "Magma General Insurance Limited",
  },
  {
    id: 55,
    label: "Narayana Health Insurance Ltd.",
    value: "Narayana Health Insurance Ltd.",
  },
  {
    id: 56,
    label: "Navi General Insurance Limited",
    value: "Navi General Insurance Limited",
  },
  {
    id: 57,
    label: "Niva Bupa Health Insurance Co Ltd.",
    value: "Niva Bupa Health Insurance Co Ltd.",
  },
  {
    id: 58,
    label: "Royal Sundaram General Insurance Company Limited",
    value: "Royal Sundaram General Insurance Company Limited",
  },
  {
    id: 59,
    label: "Zurich Kotak General Insurance Company (India) Limited",
    value: "Zurich Kotak General Insurance Company (India) Limited",
  },
];

export const YesNo = [
  { id: 1, value: "Yes", label: "Yes" },
  { id: 2, value: "No", label: "No" },
];
export const diabetesTest = [
  { id: 1, value: "HbA1C", label: "HbA1C" },
  { id: 2, value: "Fasting Blood Sugar", label: "Fasting Blood Sugar" },
];
export const diabetesTestCode = [
  { id: 1, value: "HbA1C", label: "HbA1C" },
  { id: 2, value: "FBS", label: "FBS" },
];

export const hypertensionTest = [
  { id: 1, value: "Systolic", label: "Systolic" },
  { id: 2, value: "Diastolic", label: "Diastolic" },
];

export const endorsementActions = [
  { id: "CAT02", label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_MOBILE },
  { id: "CAT12", label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_EMAIL },
  { id: "CAT01", label: ENDORSEMENT_ACTIONS.EDIT_NOMINEE_DETAIL },
  { id: "CAT06", label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_DOB },
  {
    id: "CAT07",
    label: ENDORSEMENT_ACTIONS.EDIT_INSURED_DOB,
  },
  {
    id: "CAT03",
    label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_DETAIL_WITHOUT_PINCODE,
  },
  { id: "CAT04", label: ENDORSEMENT_ACTIONS.EDIT_INSURED_DETAILS },
  {
    id: "CAT05",
    label: ENDORSEMENT_ACTIONS.EDIT_PORTABILITY_DETAILS,
  },
  { id: "CAT10", label: ENDORSEMENT_ACTIONS.EDIT_MEDICAL_DECLARATION },
  { id: "CAT11", label: ENDORSEMENT_ACTIONS.EDIT_LIFESTYLE_DECLARATION },
  { id: "CAT08", label: ENDORSEMENT_ACTIONS.ADD_MEMBER },
  { id: "CAT09", label: ENDORSEMENT_ACTIONS.DELETE_MEMBER },
  { id: "CAT13", label: ENDORSEMENT_ACTIONS.CUMULATIVE_BONUS },
];
export const endorsementActionsPA = [
  { id: "CAT02", label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_MOBILE },
  { id: "CAT12", label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_EMAIL },
  { id: "CAT01", label: ENDORSEMENT_ACTIONS.EDIT_NOMINEE_DETAIL },
  { id: "CAT06", label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_DOB },
  {
    id: "CAT07",
    label: ENDORSEMENT_ACTIONS.EDIT_INSURED_DOB,
  },
  {
    id: "CAT03",
    label: ENDORSEMENT_ACTIONS.EDIT_PROPOSER_DETAIL_WITHOUT_PINCODE,
  },
  { id: "CAT04", label: ENDORSEMENT_ACTIONS.EDIT_INSURED_DETAILS },
  { id: "CAT10", label: ENDORSEMENT_ACTIONS.EDIT_MEDICAL_DECLARATION },
  // { id: "CAT08", label: ENDORSEMENT_ACTIONS.ADD_MEMBER }
  // { id: "CAT09", label: ENDORSEMENT_ACTIONS.DELETE_MEMBER }
];
export const PRODUCTS_ELIGIBLE_FOR_ENDORSEMENT = [
  "2846",
  "28559",
  "28554",
  "28572",
  "42527",
  "28580",
];
export const PRODUCT_ELIGIBLE_FOR_PPHI = [
  "28554",
  "28572",
  "2896",
  "2833",
  "28580",
];

export const PRIORITY_ORDER = [
  "C003",
  "SUPERCHARGE_BONUS_RIDER",
  "C017",
  "HOME_CARE_TREATMENT_RIDER",
  "C018",
  "ACCIDENTAL_DEATH_BENEFIT_RIDER",
  "PREVENTIVE_ANNUAL_HEALTH_CHECKUP_RIDER",
  "INTRODUCTION_OF_VALUED_PROVIDER_NETWORK",
  "C008",
];

export const BANK_NAME = [
  { id: 1, label: "HDFC Bank", value: "hdfc bank" },
  { id: 2, label: "State Bank of India", value: "state bank of india" },
  { id: 3, label: "Punjab National Bank", value: "punjab national bank" },
  { id: 4, label: "ICICI Bank", value: "icici bank" },
  { id: 5, label: "Axis Bank", value: "axis bank" },
  { id: 6, label: "Kotak Mahindra Bank", value: "kotak mahindra bank" },
  { id: 7, label: "Bank of Baroda", value: "bank of baroda" },
  { id: 8, label: "Canara Bank", value: "canara bank" },
  { id: 9, label: "Union Bank of India", value: "union bank of india" },
  { id: 10, label: "Bank of India", value: "bank of india" },
  { id: 11, label: "IDBI Bank", value: "idbi bank" },
  { id: 12, label: "Indian Bank", value: "indian bank" },
  { id: 13, label: "Central Bank of India", value: "central bank of india" },
  { id: 14, label: "Indian Overseas Bank", value: "indian overseas bank" },
  { id: 15, label: "UCO Bank", value: "uco bank" },
  { id: 16, label: "Bank of Maharashtra", value: "bank of maharashtra" },
  { id: 17, label: "Yes Bank", value: "yes bank" },
  { id: 18, label: "IndusInd Bank", value: "indusind bank" },
  { id: 19, label: "IDFC FIRST Bank", value: "idfc first bank" },
  { id: 20, label: "Federal Bank", value: "federal bank" },
  { id: 21, label: "South Indian Bank", value: "south indian bank" },
  { id: 22, label: "RBL Bank", value: "rbl bank" },
  { id: 23, label: "Karnataka Bank", value: "karnataka bank" },
  { id: 24, label: "City Union Bank", value: "city union bank" },
  { id: 25, label: "DCB Bank", value: "dcb bank" },
  {
    id: 26,
    label: "Tamilnad Mercantile Bank",
    value: "tamilnad mercantile bank",
  },
  { id: 27, label: "Karur Vysya Bank", value: "karur vysya bank" },
  { id: 28, label: "AU Small Finance Bank", value: "au small finance bank" },
  {
    id: 29,
    label: "Equitas Small Finance Bank",
    value: "equitas small finance bank",
  },
  {
    id: 30,
    label: "Ujjivan Small Finance Bank",
    value: "ujjivan small finance bank",
  },
];

export const ACCOUNT_TYPE = [
  { id: 1, label: "Savings Account", value: "savings account" },
  { id: 2, label: "Current Account", value: "current account" },
  { id: 3, label: "Salary Account", value: "salary account" },
  { id: 4, label: "Others", value: "others" },
];

const generateMultipliers = (count) => {
  const result = [];
  for (let i = 2; i < count + 2; i++) {
    result.push({ id: i, label: `${i}x`, value: `${i}` });
  }
  return result;
};
export const HEALTH_MULTIPLIER = {
  500000: generateMultipliers(3),
  750000: generateMultipliers(6),
  1000000: generateMultipliers(1),
  1500000: generateMultipliers(3),
  2000000: generateMultipliers(2),
};

export const FED_VALUES = [
  { id: 0, value: "0", label: "0%" },
  { id: 1, value: "5", label: "5%" },
  { id: 2, value: "10", label: "10%" },
  { id: 3, value: "20", label: "20%" },
];

export const MAX_PORT_POLICY_COUNT = 10;
export const MAX_PORT_POLICY_COUNT_NB = 4;

export const CHANCE_HEADER = [
  "Feature Name",
  "Data Value",
  "Shape Value",
  "Shape Bucket Name",
];

// TO DO: Add Medicare Elite and Medicare Select Value (Whenever they go live)
export const PROFESSIONAL_DISCOUNT_PRODUCTS = [28572];

export const EMPLOYMENT_VALUE = [
  { id: 1, label: "Salaried", value: "Salaried" },
  { id: 2, label: "Self employed", value: "Self employed" },
  { id: 3, label: "HNI/Property owners", value: "HNI/Property owners" },
  { id: 4, label: "Capital Invest", value: "Capital Invest" },
  {
    id: 5,
    label: "Home Maker/ Non Salaried",
    value: "Home Maker/ Non Salaried",
  },
];
export const PA_TENURE = [
  { id: 1, label: "1yr", value: 1 },
  { id: 2, label: "2yr", value: 2 },
  { id: 3, label: "3yr", value: 3 },
  { id: 4, label: "4yr", value: 4 },
  { id: 5, label: "5yr", value: 5 },
];

export const ADDITIONAL_INSURER = [
  { id: 1, label: "Life", value: "Life" },
  { id: 2, label: "Health", value: "Health" },
  { id: 3, label: "Unit Linked", value: "Unit Linked" },
  { id: 4, label: "Pension", value: "Pension" },
  { id: 5, label: "Personal Accident", value: "Personal Accident" },
];

export const FINANCIAL_DOCUMENT_OPTIONS = [
  {
    id: 1,
    label: "Latest 3 Months Salary Slip",
    value: "Latest 3 Months Salary Slip",
  },
  {
    id: 2,
    label: "Latest year Form 16 Part A & B",
    value: "Latest year Form 16 Part A & B",
  },
  {
    id: 3,
    label: "Latest 3 years ITR and Computation of income",
    value: "Latest 3 years ITR and Computation of income",
  },
];
export const OCCUPATIONAL_DOCUMENT_OPTIONS = [
  { id: 1, label: "Salary Slip", value: "SalarySlip" },
  { id: 2, label: "Form 16", value: "Form16" },
];
export const LOAN_TYPE_OPTIONS = [
  { id: 1, label: "Home Loan", value: "Home Loan" },
  { id: 2, label: "Personal Loan", value: "Personal Loan" },
  { id: 3, label: "Auto/Vehicle Loan", value: "Auto/Vehicle Loan" },
  { id: 4, label: "Education Loan", value: "Education Loan" },
  { id: 5, label: "Business Loan", value: "Business Loan" },
  { id: 6, label: "Loan Against Property", value: "Loan Against Property" },
  { id: 7, label: "Agricultural Loan", value: "Agricultural Loan" },
  { id: 8, label: "Consumer Durable Loan", value: "Consumer Durable Loan" },
  { id: 9, label: "Gold Loan", value: "Gold Loan" },
  { id: 10, label: "Two-Wheeler Loan", value: "Two-Wheeler Loan" },
];

export const LOAN_TENURE_OPTIONS = [
  { id: 1, label: "1 Year", value: "1 Year" },
  { id: 2, label: "2 Years", value: "2 Years" },
  { id: 3, label: "3 Years", value: "3 Years" },
  { id: 4, label: "4 Years", value: "4 Years" },
  { id: 5, label: "5 Years", value: "5 Years" },
  { id: 6, label: "6 Years", value: "6 Years" },
  { id: 7, label: "7 Years", value: "7 Years" },
  { id: 8, label: "8 Years", value: "8 Years" },
  { id: 9, label: "9 Years", value: "9 Years" },
  { id: 10, label: "10 Years", value: "10 Years" },
];
export const WAITING_PERIOD = [
  { id: 0, label: "0 days", value: "0" },
  { id: 1, label: "30 days", value: "30" },
  { id: 2, label: "60 days", value: "60" },
  { id: 3, label: "90 days", value: "90" },
];
export const NUMBER_WEEKS_PAYOUT = [
  { id: 0, label: "24weeks", value: "24" },
  { id: 1, label: "48weeks", value: "48" },
  { id: 2, label: "72weeks", value: "72" },
  { id: 3, label: "104 weeks", value: "104" },
];
export const DEDUCTIBLE_OPTIONS = [
  { id: 0, label: "0 week", value: "0" },
  { id: 1, label: "1 week", value: "1" },
  { id: 2, label: "2 week", value: "2" },
  { id: 3, label: "3 week", value: "3" },
];

export const EMI_MAPPER = {
  monthly: "Monthly",
  quarterly: "Quarterly",
  half_yearly: "Half Yearly",
};

export const EMI_MAPPER_VALUE = {
  monthly: "Month",
  quarterly: "Quarter",
  half_yearly: "Half Year",
};

export const EMI_FREQUENCY = [
  { id: 0, label: "Monthly", value: "monthly" },
  { id: 1, label: "Quarterly", value: "quarterly" },
  { id: 2, label: "Half Yearly", value: "half_yearly" },
];
export const DECLINE_DISEASE_WITH_OTHERS = [
  ...DECLINE_DISEASE,
  { id: 92, label: "Others", value: "OTH" },
];

export const EMI_ENDORSEMENT_CATEGORY_LIVE = [
  "CAT01",
  "CAT02",
  "CAT12",
  "CAT03",
];

export const MEDICARE_RESERVE_BASE_DEDUCTIBLE_AND_SUM_INSURED_MAPPING = {
  500000: [300000],
  750000: [300000],
  1000000: [300000, 500000],
  1500000: [300000, 500000],
  2000000: [300000, 500000, 1000000],
  2500000: [300000, 500000, 1000000, 1500000],
  5000000: [300000, 500000, 1000000, 1500000, 2000000, 2500000, 5000000],
  7500000: [500000, 1000000, 1500000, 2000000, 2500000, 5000000],
  10000000: [500000, 1000000, 1500000, 2000000, 2500000, 5000000],
  20000000: [1000000, 1500000, 2000000, 2500000, 5000000],
  30000000: [1500000, 2000000, 2500000, 5000000],
  50000000: [2500000, 5000000],
};

export const MEDICARE_RESERVE_SUM_INSURED_DEDUCTIBLE_MAPPING = {
  // 200000: [500000, 750000, 1000000, 1500000, 2000000, 2500000],
  300000: [500000, 750000, 1000000, 1500000, 2000000, 2500000, 5000000],
  500000: [1000000, 1500000, 2000000, 2500000, 5000000, 7500000, 10000000],
  1000000: [2000000, 2500000, 5000000, 7500000, 10000000, 20000000],
  1500000: [2500000, 5000000, 7500000, 10000000, 20000000, 30000000],
  2000000: [5000000, 7500000, 10000000, 20000000, 30000000],
  2500000: [5000000, 7500000, 10000000, 20000000, 30000000, 50000000],
  5000000: [5000000, 7500000, 10000000, 20000000, 30000000, 50000000],
};
export const RESIDENTIAL_STATUS_COMMON_DOC_TYPE = [
  { id: 2, label: "Tax Documentation", value: "Tax Documentation" },
  {
    id: 3,
    label: "Work Visa / Employment Proof / Work Permit",
    value: "Work Visa / Employment Proof / Work Permit",
  },
  {
    id: 4,
    label: "Overseas Residential Proof (Lease/Rental/Ownership)",
    value: "Overseas Residential Proof (Lease/Rental/Ownership)",
  },
];
export const NRI_DOCUMENT_TYPE = [
  { id: 1, label: "Stamped VISA (NRI)", value: "Stamped VISA (NRI)" },
  ...RESIDENTIAL_STATUS_COMMON_DOC_TYPE,
];
export const OCI_DOCUMENT_TYPE = [
  { id: 1, label: "OCI Card", value: "OCI Card" },
  ...RESIDENTIAL_STATUS_COMMON_DOC_TYPE,
];
export const RESIDENTIAL_STATUS = [
  { id: 0, label: "Indian", value: "Indian" },
  {
    id: 1,
    label: "NRI",
    value: "NRI",
  },
  {
    id: 2,
    label: "OCI",
    value: "OCI",
  },
];
export const COUNTRY_OF_RESIDENCE = [
  { id: 0, label: "Afghanistan", value: "Afghanistan" },
  { id: 1, label: "Albania", value: "Albania" },
  { id: 2, label: "Algeria", value: "Algeria" },
  { id: 3, label: "Andorra", value: "Andorra" },
  { id: 4, label: "Angola", value: "Angola" },
  { id: 5, label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
  { id: 6, label: "Argentina", value: "Argentina" },
  { id: 7, label: "Armenia", value: "Armenia" },
  { id: 8, label: "Australia", value: "Australia" },
  { id: 9, label: "Austria", value: "Austria" },
  { id: 10, label: "Azerbaijan", value: "Azerbaijan" },
  { id: 11, label: "Bahamas", value: "Bahamas" },
  { id: 12, label: "Bahrain", value: "Bahrain" },
  { id: 13, label: "Bangladesh", value: "Bangladesh" },
  { id: 14, label: "Barbados", value: "Barbados" },
  { id: 15, label: "Belarus", value: "Belarus" },
  { id: 16, label: "Belgium", value: "Belgium" },
  { id: 17, label: "Belize", value: "Belize" },
  { id: 18, label: "Benin", value: "Benin" },
  { id: 19, label: "Bhutan", value: "Bhutan" },
  { id: 20, label: "Bolivia", value: "Bolivia" },
  { id: 21, label: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
  { id: 22, label: "Botswana", value: "Botswana" },
  { id: 23, label: "Brazil", value: "Brazil" },
  { id: 24, label: "Brunei", value: "Brunei" },
  { id: 25, label: "Bulgaria", value: "Bulgaria" },
  { id: 26, label: "Burkina Faso", value: "Burkina Faso" },
  { id: 27, label: "Burundi", value: "Burundi" },
  { id: 28, label: "Cabo Verde", value: "Cabo Verde" },
  { id: 29, label: "Cambodia", value: "Cambodia" },
  { id: 30, label: "Cameroon", value: "Cameroon" },
  { id: 31, label: "Canada", value: "Canada" },
  {
    id: 32,
    label: "Central African Republic",
    value: "Central African Republic",
  },
  { id: 33, label: "Chad", value: "Chad" },
  { id: 34, label: "Chile", value: "Chile" },
  { id: 35, label: "China", value: "China" },
  { id: 36, label: "Colombia", value: "Colombia" },
  { id: 37, label: "Comoros", value: "Comoros" },
  {
    id: 38,
    label: "Congo (Congo-Brazzaville)",
    value: "Congo (Congo-Brazzaville)",
  },
  { id: 39, label: "Costa Rica", value: "Costa Rica" },
  { id: 40, label: "Croatia", value: "Croatia" },
  { id: 41, label: "Cuba", value: "Cuba" },
  { id: 42, label: "Cyprus", value: "Cyprus" },
  { id: 43, label: "Czechia", value: "Czechia" },
  { id: 44, label: "Denmark", value: "Denmark" },
  { id: 45, label: "Djibouti", value: "Djibouti" },
  { id: 46, label: "Dominica", value: "Dominica" },
  { id: 47, label: "Dominican Republic", value: "Dominican Republic" },
  { id: 48, label: "Ecuador", value: "Ecuador" },
  { id: 49, label: "Egypt", value: "Egypt" },
  { id: 50, label: "El Salvador", value: "El Salvador" },
  { id: 51, label: "Equatorial Guinea", value: "Equatorial Guinea" },
  { id: 52, label: "Eritrea", value: "Eritrea" },
  { id: 53, label: "Estonia", value: "Estonia" },
  { id: 54, label: "Eswatini", value: "Eswatini" },
  { id: 55, label: "Ethiopia", value: "Ethiopia" },
  { id: 56, label: "Fiji", value: "Fiji" },
  { id: 57, label: "Finland", value: "Finland" },
  { id: 58, label: "France", value: "France" },
  { id: 59, label: "Gabon", value: "Gabon" },
  { id: 60, label: "Gambia", value: "Gambia" },
  { id: 61, label: "Georgia", value: "Georgia" },
  { id: 62, label: "Germany", value: "Germany" },
  { id: 63, label: "Ghana", value: "Ghana" },
  { id: 64, label: "Greece", value: "Greece" },
  { id: 65, label: "Grenada", value: "Grenada" },
  { id: 66, label: "Guatemala", value: "Guatemala" },
  { id: 67, label: "Guinea", value: "Guinea" },
  { id: 68, label: "Guinea-Bissau", value: "Guinea-Bissau" },
  { id: 69, label: "Guyana", value: "Guyana" },
  { id: 70, label: "Haiti", value: "Haiti" },
  { id: 71, label: "Honduras", value: "Honduras" },
  { id: 72, label: "Hungary", value: "Hungary" },
  { id: 73, label: "Iceland", value: "Iceland" },
  { id: 74, label: "Indonesia", value: "Indonesia" },
  { id: 75, label: "Iran", value: "Iran" },
  { id: 76, label: "Iraq", value: "Iraq" },
  { id: 77, label: "Ireland", value: "Ireland" },
  { id: 78, label: "Israel", value: "Israel" },
  { id: 79, label: "Italy", value: "Italy" },
  { id: 80, label: "Jamaica", value: "Jamaica" },
  { id: 81, label: "Japan", value: "Japan" },
  { id: 82, label: "Jordan", value: "Jordan" },
  { id: 83, label: "Kazakhstan", value: "Kazakhstan" },
  { id: 84, label: "Kenya", value: "Kenya" },
  { id: 85, label: "Kiribati", value: "Kiribati" },
  { id: 86, label: "Kuwait", value: "Kuwait" },
  { id: 87, label: "Kyrgyzstan", value: "Kyrgyzstan" },
  { id: 88, label: "Laos", value: "Laos" },
  { id: 89, label: "Latvia", value: "Latvia" },
  { id: 90, label: "Lebanon", value: "Lebanon" },
  { id: 91, label: "Lesotho", value: "Lesotho" },
  { id: 92, label: "Liberia", value: "Liberia" },
  { id: 93, label: "Libya", value: "Libya" },
  { id: 94, label: "Liechtenstein", value: "Liechtenstein" },
  { id: 95, label: "Lithuania", value: "Lithuania" },
  { id: 96, label: "Luxembourg", value: "Luxembourg" },
  { id: 97, label: "Madagascar", value: "Madagascar" },
  { id: 98, label: "Malawi", value: "Malawi" },
  { id: 99, label: "Malaysia", value: "Malaysia" },
  { id: 100, label: "Maldives", value: "Maldives" },
  { id: 101, label: "Mali", value: "Mali" },
  { id: 102, label: "Malta", value: "Malta" },
  { id: 103, label: "Marshall Islands", value: "Marshall Islands" },
  { id: 104, label: "Mauritania", value: "Mauritania" },
  { id: 105, label: "Mauritius", value: "Mauritius" },
  { id: 106, label: "Mexico", value: "Mexico" },
  { id: 107, label: "Micronesia", value: "Micronesia" },
  { id: 108, label: "Moldova", value: "Moldova" },
  { id: 109, label: "Monaco", value: "Monaco" },
  { id: 110, label: "Mongolia", value: "Mongolia" },
  { id: 111, label: "Montenegro", value: "Montenegro" },
  { id: 112, label: "Morocco", value: "Morocco" },
  { id: 113, label: "Mozambique", value: "Mozambique" },
  { id: 114, label: "Myanmar", value: "Myanmar" },
  { id: 115, label: "Namibia", value: "Namibia" },
  { id: 116, label: "Nauru", value: "Nauru" },
  { id: 117, label: "Nepal", value: "Nepal" },
  { id: 118, label: "Netherlands", value: "Netherlands" },
  { id: 119, label: "New Zealand", value: "New Zealand" },
  { id: 120, label: "Nicaragua", value: "Nicaragua" },
  { id: 121, label: "Niger", value: "Niger" },
  { id: 122, label: "Nigeria", value: "Nigeria" },
  { id: 123, label: "North Korea", value: "North Korea" },
  { id: 124, label: "North Macedonia", value: "North Macedonia" },
  { id: 125, label: "Norway", value: "Norway" },
  { id: 126, label: "Oman", value: "Oman" },
  { id: 127, label: "Pakistan", value: "Pakistan" },
  { id: 128, label: "Palau", value: "Palau" },
  { id: 129, label: "Panama", value: "Panama" },
  { id: 130, label: "Papua New Guinea", value: "Papua New Guinea" },
  { id: 131, label: "Paraguay", value: "Paraguay" },
  { id: 132, label: "Peru", value: "Peru" },
  { id: 133, label: "Philippines", value: "Philippines" },
  { id: 134, label: "Poland", value: "Poland" },
  { id: 135, label: "Portugal", value: "Portugal" },
  { id: 136, label: "Qatar", value: "Qatar" },
  { id: 137, label: "Romania", value: "Romania" },
  { id: 138, label: "Russia", value: "Russia" },
  { id: 139, label: "Rwanda", value: "Rwanda" },
  { id: 140, label: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
  { id: 141, label: "Saint Lucia", value: "Saint Lucia" },
  {
    id: 142,
    label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
  },
  { id: 143, label: "Samoa", value: "Samoa" },
  { id: 144, label: "San Marino", value: "San Marino" },
  { id: 145, label: "Sao Tome and Principe", value: "Sao Tome and Principe" },
  { id: 146, label: "Saudi Arabia", value: "Saudi Arabia" },
  { id: 147, label: "Senegal", value: "Senegal" },
  { id: 148, label: "Serbia", value: "Serbia" },
  { id: 149, label: "Seychelles", value: "Seychelles" },
  { id: 150, label: "Sierra Leone", value: "Sierra Leone" },
  { id: 151, label: "Singapore", value: "Singapore" },
  { id: 152, label: "Slovakia", value: "Slovakia" },
  { id: 153, label: "Slovenia", value: "Slovenia" },
  { id: 154, label: "Solomon Islands", value: "Solomon Islands" },
  { id: 155, label: "Somalia", value: "Somalia" },
  { id: 156, label: "South Africa", value: "South Africa" },
  { id: 157, label: "South Korea", value: "South Korea" },
  { id: 158, label: "South Sudan", value: "South Sudan" },
  { id: 159, label: "Spain", value: "Spain" },
  { id: 160, label: "Sri Lanka", value: "Sri Lanka" },
  { id: 161, label: "Sudan", value: "Sudan" },
  { id: 162, label: "Suriname", value: "Suriname" },
  { id: 163, label: "Sweden", value: "Sweden" },
  { id: 164, label: "Switzerland", value: "Switzerland" },
  { id: 165, label: "Syria", value: "Syria" },
  { id: 166, label: "Taiwan", value: "Taiwan" },
  { id: 167, label: "Tajikistan", value: "Tajikistan" },
  { id: 168, label: "Tanzania", value: "Tanzania" },
  { id: 169, label: "Thailand", value: "Thailand" },
  { id: 170, label: "Timor-Leste", value: "Timor-Leste" },
  { id: 171, label: "Togo", value: "Togo" },
  { id: 172, label: "Tonga", value: "Tonga" },
  { id: 173, label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
  { id: 174, label: "Tunisia", value: "Tunisia" },
  { id: 175, label: "Turkey", value: "Turkey" },
  { id: 176, label: "Turkmenistan", value: "Turkmenistan" },
  { id: 177, label: "Tuvalu", value: "Tuvalu" },
  { id: 178, label: "Uganda", value: "Uganda" },
  { id: 179, label: "Ukraine", value: "Ukraine" },
  { id: 180, label: "United Arab Emirates", value: "United Arab Emirates" },
  { id: 181, label: "United Kingdom", value: "United Kingdom" },
  { id: 182, label: "United States", value: "United States" },
  { id: 183, label: "Uruguay", value: "Uruguay" },
  { id: 184, label: "Uzbekistan", value: "Uzbekistan" },
  { id: 185, label: "Vanuatu", value: "Vanuatu" },
  { id: 186, label: "Vatican City", value: "Vatican City" },
  { id: 187, label: "Venezuela", value: "Venezuela" },
  { id: 188, label: "Vietnam", value: "Vietnam" },
  { id: 189, label: "Yemen", value: "Yemen" },
  { id: 190, label: "Zambia", value: "Zambia" },
  { id: 191, label: "Zimbabwe", value: "Zimbabwe" },
];
export const GMC_INSURANCE_COMPANY = [
  { id: 0, label: "Yes, with TATA AIG", value: "TataAig" },
  {
    id: 1,
    label: "Yes, with other insurer",
    value: "Other",
  },
  { id: 2, label: "No", value: "None" },
];
